import * as tslib_1 from "tslib";
import ForwardingForm from './ForwardingForm';
import setChoiceGroupSelectionState from '../actions/setChoiceGroupSelectionState';
import store from '../store/store';
import getChoiceGroupSelection from '../utils/getChoiceGroupSelection';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var ForwardingFull = /** @class */ (function (_super) {
    tslib_1.__extends(ForwardingFull, _super);
    function ForwardingFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChoiceGroupSelectionChange = function (ev, option) {
            setChoiceGroupSelectionState(option.key);
        };
        return _this;
    }
    ForwardingFull.prototype.render = function () {
        var selectedKey = getChoiceGroupSelection();
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_forwarding_description),
            React.createElement(ChoiceGroup, { onChange: this.onChoiceGroupSelectionChange, selectedKey: selectedKey, options: [
                    {
                        key: 'start',
                        text: strings.options_forwarding_start_forwarding_choice_label,
                        onRenderField: function (props, render) {
                            return (React.createElement("div", null,
                                render(props),
                                React.createElement(ForwardingForm, null)));
                        },
                    },
                    {
                        key: 'stop',
                        text: strings.options_forwarding_stop_forwarding_choice_label,
                    },
                ] })));
    };
    ForwardingFull = tslib_1.__decorate([
        reactive({
            optionState: function () { return store; },
        })
    ], ForwardingFull);
    return ForwardingFull;
}(React.Component));
export default ForwardingFull;
//# sourceMappingURL=ForwardingFull.js.map